import { doesEmployeeNeedBIC } from '@vivaldis/common'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Input, Typography } from '@vivaldis/antd-ui'
import { useForm } from '../../../../provider/FormProvider'

export const BankAccountSection = () => {
  const [t] = useTranslation('web_ui')

  const { values } = useForm()

  const showBic = useMemo(() => {
    if (values.bic) {
      return true
    }

    if (doesEmployeeNeedBIC(values.bankAccount)) {
      return true
    }

    return false
  }, [values.bankAccount, values.bic])

  return (
    <>
      <Typography.Title level={5} marginBottom={16}>
        {t(
          'edit_employee_general_information_form.bank_account_section_header'
        )}
      </Typography.Title>
      <Form.Item
        name="bankAccount"
        required
        label={t('edit_employee_general_information_form.bank_account.label')}
      >
        <Input
          name="bankAccount"
          placeholder={t('form.required')}
          autoComplete="off"
        />
      </Form.Item>
      {showBic ? (
        <Form.Item
          name="bic"
          required={doesEmployeeNeedBIC(values.bankAccount)}
          label={t('edit_employee_general_information_form.bic.label')}
        >
          <Input
            name="bic"
            placeholder={t('form.required')}
            autoComplete="off"
          />
        </Form.Item>
      ) : null}
    </>
  )
}
